<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="path in paths" :key="path">
      {{ $t(`r.${path}`) }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const paths = computed(() => {
  return route.path.split("/").filter((item) => {
    return "" !== item;
  });
});
</script>
<style lang="less" scoped>
.el-breadcrumb__item {
  font-size: 16px;
}
.el-breadcrumb {
  margin-bottom: 10px;
}
</style>
